import React from 'react';
import { TextDefault, palette } from '@awarego-ui/components';
import TableClient from '../../components/table/TableClient';
import { observer } from 'mobx-react';
import { diffValues } from '../../utils/helpers';

const sortByKeyOrField = (arr) =>
    [...arr].sort((a, b) => {
        const aKey = a.key ?? a.field ?? '';
        const bKey = b.key ?? b.field ?? '';
        return aKey.localeCompare(bKey, undefined, { numeric: true, sensitivity: 'base' });
    });

function AuditModalContent({ entry }) {
    if (!entry) return null;

    if (entry.type === 'diff') {
        const diff = diffValues(entry.oldValues, entry.newValues);
        const sortedDiff = sortByKeyOrField(diff);

        return (
            <TableClient
                columns={[
                    { Header: 'Field', accessor: 'key' },
                    {
                        Header: 'Old value',
                        accessor: 'oldVal',
                        Cell: ({ value, row }) => (
                            <TextDefault
                                color={
                                    row.original.status === 'deleted'
                                        ? palette.vibrant.red
                                        : undefined
                                }
                            >
                                {String(value ?? '')}
                            </TextDefault>
                        ),
                    },
                    {
                        Header: 'New value',
                        accessor: 'newVal',
                        Cell: ({ value, row }) => (
                            <TextDefault
                                color={
                                    row.original.status === 'added'
                                        ? palette.evergreen.aspargus
                                        : row.original.status === 'changed'
                                            ? palette.vibrant.gold
                                            : undefined
                                }
                            >
                                {String(value ?? '')}
                            </TextDefault>
                        ),
                    },
                ]}
                data={sortedDiff}
                disableSorting={true}
                hidePagination
                initialPageSize={10}
            />
        );
    }

    // ---- NOT DIFF ----
    const valuesObj = Object.keys(entry.newValues || {}).length
        ? entry.newValues
        : entry.oldValues || {};

    const valueColor =
        entry.type === 'log_delete'
            ? palette.vibrant.red
            : entry.type === 'log_create'
                ? palette.evergreen.aspargus
                : undefined;

    const tableData = Object.entries(valuesObj).map(([key, value]) => ({
        field: key,
        value,
    }));

    const sortedTableData = sortByKeyOrField(tableData);

    return (
        <TableClient
            columns={[
                { Header: 'Field', accessor: 'field' },
                {
                    Header: 'Value',
                    accessor: 'value',
                    Cell: ({ value }) => (
                        <TextDefault color={valueColor}>
                            {String(value ?? '')}
                        </TextDefault>
                    ),
                },
            ]}
            data={sortedTableData}
            disableSorting={true}
            hidePagination
            initialPageSize={10}
        />
    );
}

export default observer(AuditModalContent);
